import React, { useContext, useEffect, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { Container, Stack, styled } from '@mui/system';
import {
  CircularProgress, Paper, Typography,
} from '@mui/material';
import { getInviteGql } from '../InviteResponse/gql';
import RsvpHeading from '../../Components/RsvpHeading';
import { GeneralContext } from '../../util/Store';

const PaperBox = styled(Paper)({
  padding: '36px 36px 36px 36px',
  paddingBottom: 10,
  position: 'relative',
});

const ErrorTypo = styled(Typography)({
  textAlign: 'center',
  marginTop: '35vh',
});

export default function Closed() {
  const { inviteCode } = useParams();
  const snackbar = useSnackbar();
  const generalStore = useContext(GeneralContext);
  const {
    data,
    loading,
  } = useQuery(getInviteGql, {
    fetchPolicy: 'no-cache',
    variables: {
      inviteCode,
    },
    onError: () => snackbar.showMessage('Fehler beim laden.'),
  });

  useEffect(() => {
    if (!data?.getInvite) return;
    generalStore.setContactInfo(data?.getInvite.inviteForm.frontendSettings.contactInfo);
  }, [data?.getInvite]);

  const invite = useMemo(() => data?.getInvite, [data?.getInvite]);

  if (!invite || loading) {
    return (
      <Stack alignItems="center" sx={{ mt: 5 }}>
        <CircularProgress />
      </Stack>
    );
  }

  if (!inviteCode) return (<ErrorTypo variant="h2">Fehlerhafter Link</ErrorTypo>);
  return (
    <Container maxWidth="lg">
      <RsvpHeading />
      <PaperBox sx={{ pb: 4, mb: 2 }} elevation={4}>
        <Typography sx={{ textAlign: 'center', mb: 2 }} variant="h4">
          Die Registrierung für die Operngala 2024 ist geschlossen.
        </Typography>
        <Typography sx={{ textAlign: 'center' }}>
          Wir freuen uns, wenn wir Sie im nächsten Jahr zur Operngala begrüßen dürfen.
        </Typography>
        <Typography sx={{ textAlign: 'center' }}>
          Wenn Sie künftig keine Einladung mehr erhalten möchten, senden Sie uns bitte eine kurze E-Mail.
        </Typography>
      </PaperBox>
    </Container>
  );
}
